// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2aE-q","errorLogs":"styles_errorLogs__1S5q8"};